import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import { TopStats, LogoMarquee } from '../components/Stats';
import Services from '../components/Services';
import Features from '../components/Features';
import Flexibility from '../components/Flexibility';
import HowItWorks from '../components/HowItWorks';
import { Results, Testimonials } from '../components/Social';
import Support from '../components/Support';
import FAQ from '../components/FAQ';
import { CTASection, Footer } from '../components/FooterCTA';
import useReveal from '../hooks/useReveal';
import useCMS from '../hooks/useCMS';

export default function HomePage() {
  useReveal();
  const { cms } = useCMS();

  return (
    <>
      <Navbar />
      <main>
        <Hero cms={cms?.hero} />
        <TopStats />
        <Services cms={cms?.services} />
        <Features cms={cms?.features} />
        <Flexibility />
        <HowItWorks />
        <Results cms={cms?.results} />
        <Testimonials cms={cms?.testimonials} />
        <LogoMarquee />
        <Support />
        <FAQ cms={cms?.faq} />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
